
<template>
    <div class="about-section">
      <article class="box">
        <header>
          <h3><span>Social Media Accounts</span></h3>
          <span @click="editing=true" v-if="!editing && editable">
            <button class="button is-small is-white">
              <i class="fal fa-pencil-alt has-text-primary" aria-hidden="true"></i>&nbsp;<span class="editText has-text-primary">{{$t('edit')}}</span>
            </button>
          </span>
          <span class="close-button" v-if="editing">
            <button class="button is-small is-primary" @click="editing=false">Close</button>
          </span>
        </header>
        <social-handles :user="this.user" :displayMode="displayMode" ref="socialHandles" @handlesAvailable="handlesAvailable"></social-handles>
        <span v-if="!handlesAmount && !editing && editable">{{$t('social')}}</span>
      </article>
    </div>
</template>

<script>
import SocialHandles from '@/components/Controls/SocialHandles'
import state from '../../state'
import componentState from '@/mixins/component-state'
export default {
  props: ['user'],
  components: {
    SocialHandles
  },
  data: function () {
    return {
      editing: false,
      handlesAmount: 0
    }
  },
  mixins: [componentState],
  computed: {
    displayMode: function () {
      return this.editing && this.editable ? 'edit' : 'static'
    },
    editable: function () {
      return this._get(state.editable.profile, false)
    }
  },
  methods: {
    handlesAvailable: function (number) {
      this.handlesAmount = number
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';
    h3{
      font-weight:600;
    }
    header {
      display: flex;
    }

    .close-button {
      margin-left: 0.25rem;
    }
    ::v-deep .inputsocial input {
      border: red solid 2px;
      background-color: whitesmoke;
    }
</style>
